import { type FC, type Ref } from "react"
import { type LinkProps, Link as RouterLink } from "react-router"

import { useIsOutdated } from "~/contexts/VersionContext"

type Props = Omit<LinkProps, "reloadDocument"> & { ref?: Ref<HTMLAnchorElement> }
const Link: FC<Props> = props => {
	const isOutdated = useIsOutdated()

	return <RouterLink reloadDocument={isOutdated} {...props} />
}

export default Link
